import { SelectDesignTokens } from '@primeuix/themes/types/select';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/select/index.ts

export const SelectTelekomDT: SelectDesignTokens = {};
